export default {
  REASON: "Motif",
  REASON_PLACEHOLDER: "Choisissez un motif",
  REASON_DETAIL: "Précision",
  REASON_DETAIL_PLACEHOLDER: "Précisez si nécessaire",
  REASON_DETAIL_REQUIRED_HELP:
    "La précision est obligatoire lorsque le motif choisi est « Autre ».",
  CONFIRM: "Confirmer",

  CANCELLATION_REASONS: {
    WRONG_QUANTITY: "Quantité erronée",
    NOT_RECEIVED: "Produits non reçus",
    DUPLICATE: "Facture en double",
    WRONG_DAY: "Journée erronée",
    OTHER: "Autre",
  },

  NON_RECEPTION_REASONS: {
    OPENING_DELAYED: "Ouverture de la cafétéria retardée",
    CAFETERIA_CLOSED: "Cafétéria fermée ce jour-là",
    SCHOOL_CLOSED: "École fermée (congé, tempête, journée pédagogique)",
    NOT_DELIVERED: "Livraison non effectuée par la production",
    CANCELED_WITH_PRODUCTION: "Journée annulée d'un commun accord avec la production",
    ORDER_ERROR: "Journée commandée par erreur",
    OTHER: "Autre",
  },

  REJECTION_REASONS: {
    CAPACITY: "Capacité de production insuffisante",
    PRODUCTS_UNAVAILABLE: "Produits non disponibles",
    WRONG_CONTENT: "Contenu de la commande erroné",
    OTHER: "Autre",
  },

  DISCREPANCIES: {
    QUANTITY_DIFFERS: "Quantité différente",
    NOT_DELIVERED: "Commandé, non reçu",
    NOT_ORDERED: "Reçu, non commandé",
  },

  DISCREPANCIES_TITLE: "Écarts entre la commande et la réception",
  DISCREPANCIES_HELP:
    "Cette réception s'écarte de la journée commandée : elle attend l'acceptation de l'établissement de production. Une réception conforme est acceptée automatiquement.",
  DISCREPANCY: "Écart",
  ORDERED: "Commandé",
  RECEIVED: "Reçu",

  AUTO_ACCEPTED: "Acceptée automatiquement",
  AUTO_ACCEPTED_HELP:
    "La réception correspondait exactement à ce qui était commandé pour la journée : aucune acceptation n'a été nécessaire.",

  CANCEL_INVOICE_TITLE: "Annuler la facture interne",
  CANCEL_INVOICE_HELP:
    "L'annulation retire la facture des rapports hebdomadaires des deux établissements et rouvre la journée. L'autre école en est avertie par courriel, avec le motif.",
  REJECT_ORDER_TITLE: "Refuser la commande interne",
  REJECT_ORDER_HELP:
    "L'établissement satellite est averti par courriel que sa semaine ne sera pas produite, avec le motif.",

  CANCELED_BY: "Annulée par",
  CANCELED_AT: "Annulée le",
  CANCELLATION_REASON: "Motif d'annulation",
  NON_RECEPTION: "Journée non reçue",
  NON_RECEPTION_HELP:
    "Rien n'a été reçu pour cette journée commandée : cette facture à 0 $ la clôt. L'établissement de production l'accepte après avoir pris connaissance du motif, ou l'annule pour rouvrir la journée.",
  NON_RECEPTION_REASON: "Motif de non-réception",
  REJECTED_BY: "Refusée par",
  REJECTED_AT: "Refusée le",
  REJECTION_REASON: "Motif du refus",

  LOCKED_BY_VALIDATED_WEEKLY_REPORT:
    "Impossible : un rapport hebdomadaire couvrant cette journée est déjà validé.",
};
